import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/invoices/${number | ':invoiceId'}/invoice`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/invoices/:invoiceId/invoice`;

export const URL = (jobId: number, invoiceId: number): RouteDefinition => `${baseRoute}/${jobId}/invoices/${invoiceId}/invoice`;
